function progressSpy(scrollPos) {
  const winScroll = scrollPos;
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolled = (winScroll / height) * 100;
  if (!!document.getElementById('scrollspyProgressBar')) {
    document.getElementById('scrollspyProgressBar').style.width = scrolled + '%';
  }
}

let lastKnownScrollPosition = 0;
let ticking = false;

// Reference: //www.html5rocks.com/en/tutorials/speed/animations/
window.addEventListener('scroll', function() {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function() {
      progressSpy(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});